<template>
    <activix-spinner
        class="h-6 w-6 text-gray-400"
        data-testid="attachment-image-spinner"
        v-if="!blobUrl && !error"
    />
    <img
        :src="blobUrl"
        :alt="attachment.filename"
        :class="imageClass"
        data-testid="attachment-image-loaded"
        v-else-if="blobUrl"
    />
    <span class="text-sm text-gray-400 italic" data-testid="attachment-image-error" v-else>
        {{ attachment.filename }}
    </span>
</template>

<script setup lang="ts">
    import { onMounted, ref } from 'vue';
    import type { MessageAttachment } from '@/entities/types/ConversationType.ts';
    import { useAttachmentDownload } from '@/hooks/useAttachmentDownload.ts';
    import ActivixSpinner from '@/components/activix-ui/ActivixSpinner/ActivixSpinner.vue';

    interface Props {
        attachment: MessageAttachment;
        imageClass?: string;
    }

    const props = defineProps<Props>();

    const { fetchAttachmentBlobUrl } = useAttachmentDownload();

    const blobUrl = ref<string | null>(null);
    const error = ref<boolean>(false);

    onMounted(async () => {
        try {
            blobUrl.value = await fetchAttachmentBlobUrl(props.attachment);
        } catch {
            error.value = true;
        }
    });
</script>
